import React from 'react';
import { Card } from 'antd';

function InstructionItem({ title }) {
  return (
    <div className="docs-instruction">
      <img
        src="/img/instruction.png"
        alt=""
        className="docs-instruction__img"
      />
      <a href="#" className="docs-instruction__link">
        {title}
      </a>
    </div>
  );
}

function DocsVideoInstructionsCard({ t }) {
  return (
    <Card className="docs__item docs-item">
      <div className="docs-item__title">{t('video-instruction')}</div>
      <div className="docs-item__content docs-item__content--instructions">
        <InstructionItem title={t('adding-playlist')} />
        <InstructionItem title={t('adding-devices')} />
        <InstructionItem title={t('create-playlists')} />
        <InstructionItem title={t('create-playlist-link')} />
      </div>
    </Card>
  );
}

export default DocsVideoInstructionsCard;
